 import { useAuthentication } from 'gw-digital-auth-react';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { messages as paymentMessages } from 'gw-capability-policychange-common-react';
import {PackageInfoComponent} from 'gw-capability-policychange-ho-react';

import styles from './PackageInfoPage.module.scss';
import metadata from './PackageInfoPage.metadata.json5';
import messages from './PackageInfoPage.messages';


const { env } = appConfig;

function PackageInfoPage(props) {
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [isPageInitialized, setPageInitialized] = useState(false);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const {
        wizardData, updateWizardData, isNewSubmission, additionalWizardData, updateAdditionalWizardData
    } = props;
    const submissionVM  = wizardData;
    const {
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate
    } = useValidation('PackageInfoPage');

    const [accountContacts, setAccountContacts] = useState([]);
    const [policyLocations, setPolicyLocations] = useState([]);
    const nonValidatedForms  = ['miscitem_ey','seatrailers_ey','marine_ey'];
    const nonValidatedCoveragePart = ['nonpackage_ey'];

    useEffect(() => {   
        _.each(submissionVM.lobData.homeowners.allCoverables.children, (cov, index)=> {
            if(!cov.isPrimary.value && additionalWizardData && additionalWizardData.packageInfoDetails && additionalWizardData.packageInfoDetails[cov.publicID.value]) {
                cov.location.value = {
                    isValidationRequired: true
                };
            }
        });     
        if(!isPageInitialized){
            if (submissionVM.lobData.homeowners.coverables.yourHome && _.isEmpty(submissionVM.lobData.homeowners.coverables.yourHome.value)) {
                // eslint-disable-next-line no-param-reassign
                submissionVM.lobData.homeowners.coverables.yourHome = {};
                 //updateWizardData(submissionVM);
            }
            if (submissionVM.lobData.homeowners.coverables.construction && _.isEmpty(submissionVM.lobData.homeowners.coverables.construction.value)) {
                // eslint-disable-next-line no-param-reassign
                submissionVM.lobData.homeowners.coverables.construction = {};
               // updateWizardData(submissionVM);
            }
            if (submissionVM.lobData.homeowners.coverables.rating && _.isEmpty(submissionVM.lobData.homeowners.coverables.rating.value)) {
                // eslint-disable-next-line no-param-reassign
                submissionVM.lobData.homeowners.coverables.rating = {};
                //updateWizardData(submissionVM);
            }
            
            if(policyLocations.length == 0) {
                LoadSaveService.getPolicyLocations(
                    submissionVM.quoteID.value, false,
                    authHeader
                ).then((locations) => {
                    const _locations = locations.map((c) => {
                        c['id'] = c.publicID;
                        return c
                    });
                    setPolicyLocations(_locations);
                });    
            }    
            
            if(accountContacts.length == 0) {
                LoadSaveService.getAccountContacts(
                    submissionVM.quoteID.value,
                    authHeader
                ).then((contacts) => {
                    const _contacts = contacts.map((c) => {
                        c['id'] = c.publicID;
                        return c
                    });
                    _contacts.push({ id: "placeholder", displayName: translator(messages.searchContact) });
                    setAccountContacts(_contacts);
                })
            }
            updateWizardData(submissionVM);
            setPageInitialized(true);
        }
        
        // The above action only need to run once when the page is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LoadSaveService,authHeader, submissionVM, isPageInitialized, additionalWizardData]);


    const updateLocations = (locations) => {
        const _locations = locations.map((c) => {
            c['id'] = c.publicID;
            return c
        });
        setPolicyLocations(_locations);
    }

    const updateAccountContacts = (contacts) => {
        const _contacts = contacts.map((c) => {
            c['id'] = c.publicID;
            return c
        });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
    }

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `lobData.homeowners.allCoverables.children.${index}.value`, value);
        updateWizardData(newSubmissionVM);
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const generateOverrides = () => {
        const overrides = submissionVM.lobData.homeowners.allCoverables.children.map((item, index) => {
            const required = !(nonValidatedCoveragePart.includes(item.coveragePart.value.code) && 
                            nonValidatedForms.includes(item.coverageForm.value.code))
            item.isHoValidationRequired.value = required;
            item.omiaDetail.isValidationRequired.value = required;
            return {
                [`packageAccordion${index}`]: {
                    defaultOpenedId:`packageAccordionCard${0}` 
                },
                [`packageAccordionCard${index}`]: {
                    header: `Package ${index + 1} - ${translator({ id: item['omiaDetail'].coverageForm.value.name })} ${translator({ id: item['omiaDetail'].coveragePart.value.name })}`,
                    className: 'packageAccordionHeader',
                    cardHeadingClassName:"packageAccordionHeading",
                    chevronAlignment:"right"
                },
                [`packageInfoComponent${index}`]: {
                    policyLocations: policyLocations,
                    accountContacts: accountContacts,                    
                    authHeader: authHeader,
                    coverableVM: item,
                    updateLocations: updateLocations,
                    updateAccountContacts:updateAccountContacts,
                    jobID: _.get(submissionVM, 'quoteID.value'),
                    accountNumber: _.get(submissionVM, 'baseData.accountNumber.value'),
                    updatePackage: (coverable) => {
                        updatePackage(coverable, index);
                    },
                    onValidate:onValidate,
                    packageIndex: index,
                    isSubmission: 'true',
                    additionalWizardData,
                    updateAdditionalWizardData
                }                
            };
        });
        return Object.assign({}, ...overrides);
    }
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {
            packageInfoComponent:PackageInfoComponent,
        },
    };

    const onNext = useCallback(async () => {
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );

        return submissionVM;
    }, [submissionVM, LoadSaveService, authHeader]);

    
    const handlePageValidation = useCallback(() => {
        const ratings = _.get(submissionVM.value, 'lobData.homeowners.coverables.rating');
        const quoteData = _.get(submissionVM.value, 'quoteData.offeredQuotes');
        const periodStatus = _.get(submissionVM.value, 'baseData.periodStatus');
        return (
            _.some(quoteData, (quote) => quote.status === 'Quoted')
            && periodStatus === 'Quoted'
            && ratings
        );
    }, [submissionVM]);

    const isPackageComponentValid = useCallback(() => {
        let omiaDetailField = true;
        submissionVM.lobData.homeowners.allCoverables.value.filter((c) => {
            if(c.coveragePart !== "nonpackage_ey" && (!!c.omiaDetail.isARFCoverableEffectiveJuly2024)){
                if(c.omiaDetail.numFamilies === undefined 
                    || c.omiaDetail.buildingArea === undefined 
                    || c.omiaDetail.numStories === undefined
                    || c.omiaDetail.primaryConstructionType === undefined
                    || c.omiaDetail.secondaryConstructionType === undefined
                    || c.omiaDetail.basementFinishedPercent === undefined
                    || c.omiaDetail.structureType === undefined
                    || c.omiaDetail.foundationType === undefined
                    || c.omiaDetail.numOfKitchens === undefined) {
                    omiaDetailField = false;
                } else{
                    omiaDetailField = true;
                }
            }   
        })
        return omiaDetailField;
    }, [submissionVM]);


    useEffect(() => {
        registerInitialComponentValidation(handlePageValidation);
    }, [handlePageValidation, registerInitialComponentValidation]);


    if (!isPageInitialized) {
        return null;
    }

    const skipInitialValidation = () => {
        return submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && !isNewSubmission;
    }


    return (
        <WizardPage onNext={onNext} skipWhen={skipInitialValidation} disableNext={!isPackageComponentValid() || !submissionVM.lobData.homeowners.allCoverables.aspects.subtreeValid}>
               <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PackageInfoPage.propTypes = wizardProps;
export default PackageInfoPage;
